import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { HashRouter, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import _get from 'lodash-es/get';
import _noop from 'lodash-es/noop';

// sushiweb
import ToastContainer from 'sushiweb/ToastContainer';
import Toast from 'sushiweb/Toast';

// helpers
import { isUserLoggedIn } from './utility';
import { closeToast } from './reducers/uiLogic';
import { authCheckInitiate } from './actions/auth';
import { getCompanyDetailsInitiate } from './actions/company';

// Routes
import {
  CREATE_GROUPS,
  EDIT_GROUPS,
  EMPLOYEES_ROUTE,
  EMPLOYEE_DETAILS_ROUTE,
  GROUP_DETAILS_ROUTE,
  ONBOARDING_ROUTE,
  PROGRAMS_ROUTE,
  PROGRAM_DETAILS_ROUTE,
  UPLOAD_EMPLOYEES,
  UPLOAD_EMPLOYEES_STATUS,
  // PAYMENTS_ROUTE,
  HOME_ROUTE,
  EVENT_DETAILS,
  PAYMENTS_ROUTE,
  CHECKOUT_ONLINE_PAY_ROUTE,
  PAYMENT_EVENT_DETAILS,
  HOME_EMPLOYEE_DETAILS_ROUTE,
  INVOICE_DETAILS_ROUTE,
  PAY_INVOICE_ROUTE,
} from './constants/routes';

// Components
import Loader from './pages/common/components/Loader';
import HeaderNav from './pages/common/components/Header';
import SideNavbar from './pages/common/components/SideNavbar';
import RootComponent from './pages/common/components/RootComponent';
import ProtectedRoute from './pages/common/components/ProtectedRoute';
import GlobalPopups from './pages/common/components/GlobalPopups';

// Pages
import Onboarding from './pages/Onboarding';
import WalletPrograms from './pages/WalletPrograms';
import ProgramInfo from './pages/ProgramInfo';
import UploadEmployees from './pages/Employees/components/UploadEmployees';
import Employees from './pages/Employees';
import EmployeeDetails from './pages/EmployeeDetails';
import CreateGroups from './pages/Groups/components/CreateGroups';
import GroupDetails from './pages/GroupDetails';
import UploadStatus from './pages/UploadStatus';
// import Payments from './pages/Payments';
import Dashboard from './pages/Dashboard';
import ErrorPage from './pages/common/components/ErrorPage';
import {
  REFRESH_LABEL,
  applicableFlowTypes,
  currentFlowTypeEnum,
} from './pages/common/components/constants';
import NotFound from './pages/common/components/NotFound';
import Login from './pages/Login';
import EventDetails from './pages/EventDetails';
import Payments from './pages/Payments';
import OnlinePaymentCheckoutPage from './pages/Payments/OnlinePaymentCheckoutPage';
import InvoiceDetails from './pages/Payments/Invoices/InvoiceDetails';
// import NotFound from './pages/common/components/NotFound';

const Routes = ({
  userDetails,
  // verified,
  currentFlow,
  isLoggedIn,
  companyProfile,
  selectedWorkspace,
  fetchingCompanyProfile,
  fetchedCompanyProfile,
  getCompanyDetails,
  toastDetails,
  removeToast,
  isAuthenticating,
  Authenticated,
  dispatchToAuthenticate,
  isOnlinePaymentsEnabled,
}) => {
  const refreshPage = () => {
    dispatchToAuthenticate();
  };

  useEffect(() => {
    if (!isLoggedIn) {
      dispatchToAuthenticate();
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      getCompanyDetails();
    }
  }, [isLoggedIn]);

  if (isAuthenticating || fetchingCompanyProfile) {
    return <Loader />;
  }

  if (!Authenticated) {
    return <Login isLoggedIn={isLoggedIn} />;
  }

  if (!fetchedCompanyProfile) {
    return (
      <ErrorPage
        showAction
        actionLabel={REFRESH_LABEL}
        clickAction={refreshPage}
      />
    );
  }
  return (
    <HashRouter>
      <GlobalPopups />
      <ToastContainer>
        <Toast
          show={!!toastDetails.show}
          align='top'
          onClose={removeToast}
          text={toastDetails.text}
          type={toastDetails.type}
        />
      </ToastContainer>
      <HeaderNav
        userDetails={userDetails}
        isLoggedIn={isLoggedIn}
        selectedWorkspace={selectedWorkspace}
        companyProfile={companyProfile}
        currentFlow={currentFlow}
      />
      <Switch>
        <ProtectedRoute
          isLoggedIn={isLoggedIn}
          exact
          // verified
          path={ONBOARDING_ROUTE}
          component={Onboarding}
        />
        <ProtectedRoute
          isLoggedIn={isLoggedIn}
          exact
          // verified={verified}
          path={UPLOAD_EMPLOYEES}
          component={UploadEmployees}
        />
        <ProtectedRoute
          isLoggedIn={isLoggedIn}
          exact
          // verified={verified}
          path={CREATE_GROUPS}
          component={CreateGroups}
        />
        <ProtectedRoute
          isLoggedIn={isLoggedIn}
          // verified={verified}
          path={EDIT_GROUPS}
          component={CreateGroups}
        />
        <>
          <SideNavbar
            isLoggedIn={isLoggedIn}
            // verified={verified}
            isOnlinePaymentsEnabled={isOnlinePaymentsEnabled}
          />
          <Switch>
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={HOME_ROUTE}
              component={Dashboard}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={PROGRAMS_ROUTE}
              component={WalletPrograms}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              // verified={verified}
              path={PROGRAM_DETAILS_ROUTE}
              component={ProgramInfo}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={EMPLOYEES_ROUTE}
              component={Employees}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              // verified={verified}
              path={EMPLOYEE_DETAILS_ROUTE}
              component={EmployeeDetails}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              // verified={verified}
              path={HOME_EMPLOYEE_DETAILS_ROUTE}
              component={EmployeeDetails}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              path={EVENT_DETAILS}
              component={EventDetails}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              path={PAYMENT_EVENT_DETAILS}
              component={EventDetails}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              // verified={verified}
              path={UPLOAD_EMPLOYEES_STATUS}
              component={UploadStatus}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={GROUP_DETAILS_ROUTE}
              component={GroupDetails}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={PAYMENTS_ROUTE}
              component={Payments}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={CHECKOUT_ONLINE_PAY_ROUTE}
              component={OnlinePaymentCheckoutPage}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              // verified={verified}
              path={INVOICE_DETAILS_ROUTE}
              component={InvoiceDetails}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              exact
              // verified={verified}
              path={PAY_INVOICE_ROUTE}
              component={OnlinePaymentCheckoutPage}
            />
            {/* <ProtectedRoute
              path='*'
              component={NotFound}
            /> */}
            <RootComponent
              isLoggedIn={isLoggedIn}
              //  verified={verified}
            />
          </Switch>
        </>
        <ProtectedRoute path='*' component={<NotFound />} />
      </Switch>
    </HashRouter>
  );
};

const mapStateToProps = state => {
  const companyState = _get(state, 'apiState.GET_COMPANY_PROFILE', {});
  const companyProfile = _get(state, 'company', {});
  const isOnlinePaymentsEnabled = _get(
    state,
    'user.online_payments_enabled',
    true,
  );
  return {
    companyProfile,
    isLoggedIn:
      isUserLoggedIn(state) && _get(state, 'apiState.AUTH_CHECK.success', true),
    isAuthenticated: _get(state, 'apiState.AUTH_CHECK.success', true),
    userDetails: _get(state, 'user', {}),
    selectedWorkspace: _get(state, 'user.selectedWorkspace', {}),
    currentFlow: _get(
      state,
      'user.currentFlow',
      currentFlowTypeEnum.FLOW_TYPE_PPI,
    ),
    // verified: _get(state, 'company.verified', false),
    toastDetails: _get(state, 'uiLogic.toastDetails', {}),
    fetchingCompanyProfile:
      _get(companyState, 'isFetching', false) &&
      !_get(companyState, 'isIdle', false),
    fetchedCompanyProfile: _get(companyState, 'success', false),
    isAuthenticating:
      _get(state, 'apiState.AUTH_CHECK.isFetching', true) &&
      !_get(state, 'apiState.AUTH_CHECK.isIdle', false),
    Authenticated: _get(state, 'apiState.AUTH_CHECK.success', true),
    isOnlinePaymentsEnabled,
  };
};

const mapDispatchToProps = dispatch => ({
  removeToast: () => dispatch(closeToast()),
  getCompanyDetails: () => dispatch(getCompanyDetailsInitiate()),
  dispatchToAuthenticate: () => dispatch(authCheckInitiate()),
});

Routes.propTypes = {
  userDetails: PropTypes.objectOf(PropTypes.any),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  // verified: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  getCompanyDetails: PropTypes.func,
  fetchingCompanyProfile: PropTypes.bool,
  fetchedCompanyProfile: PropTypes.bool,
  isAuthenticating: PropTypes.bool,
  Authenticated: PropTypes.bool,
  toastDetails: PropTypes.shape({
    show: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  removeToast: PropTypes.func.isRequired,
  dispatchToAuthenticate: PropTypes.func.isRequired,
  companyProfile: PropTypes.objectOf(PropTypes.any),
  isOnlinePaymentsEnabled: PropTypes.bool,
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
};

Routes.defaultProps = {
  userDetails: {},
  isLoggedIn: false,
  selectedWorkspace: {},
  fetchingCompanyProfile: false,
  fetchedCompanyProfile: false,
  // verified: false,
  isAuthenticating: true,
  Authenticated: false,
  getCompanyDetails: _noop,
  companyProfile: {},
  isOnlinePaymentsEnabled: false,
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Routes);
